import Vue from "vue";

const locale = "pt-br";
const numeral = require("numeral");
require(`numeral/locales/${locale}`);
numeral.locale(locale);

Vue.prototype.$numeral = numeral;
Vue.filter("money", function(value) {
  return numeral(value).format("$ 0,0.00");
});
